import { Controller } from "@hotwired/stimulus"

// Backs the floating "back to top" link on long content pages (see help/index.html.erb) --
// visible by default, so it still works with JavaScript disabled, then hidden until the reader
// has actually scrolled far enough down that jumping back to the top is useful. The jump itself
// needs no JS at all: it's a plain `<a href="#top">`, animated by the `scroll-behavior: smooth`
// rule in application.bootstrap.scss.
export default class extends Controller {
  static values = { threshold: { type: Number, default: 400 } }
  static classes = ["hidden"]

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    this.element.classList.toggle(this.hiddenClass, window.scrollY <= this.thresholdValue)
  }
}
